module.exports = __webpack_public_path__ + "img/Mockup 3.bd137e80.png";